import React, {FC} from 'react';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';

export type AddButtonProps = {
  onClick: () => void,
  disabled: boolean
};

const AddButton: FC<AddButtonProps> = ({onClick, disabled}) => {
  return <Fab sx={styles.fab} size="small" onClick={onClick} disabled={disabled}>
    <AddIcon sx={{color: 'white'}}/>
  </Fab>;
};
export default AddButton;

const styles = {
  fab: {
    '&.MuiButtonBase-root': {
      borderRadius: '100%',
      backgroundColor: 'primary.main',
      '&:hover': {
        backgroundColor: 'secondary.main',
      }
    },
    '&.Mui-disabled': {
      backgroundColor: '#d7d7d7'
    }
  }
};